module.exports = __webpack_public_path__ + "img/icons8-summer-50.37e53a72.svg";